import { Link } from 'react-router-dom';
import { CirclePlus } from 'lucide-react';
import SearchForm from './components/list/SearchForm';
import ListCompanies from './components/list/List';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const List = () => {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle>Companies</CardTitle>
          <Button asChild>
            <Link to="/company/add">
              <CirclePlus />
              Add Company
            </Link>
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <SearchForm />
        <ListCompanies />
      </CardContent>
    </Card>
  );
};

export default List;
